// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nq-0";